<kendo-stacklayout gap="30" orientation="horizontal" style="height:100%">
  <img #backgroundImage style="display:none" />
  @if(showLoginScreen){
    <div class="background">
      <div class="container">
        <kendo-card class="i-card">
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="header">
              <img class="headerImg" src="../../../../assets/images/epclogo.png" />
              <h3 class="headerText">EPC Redeployment</h3>
            </div>
            <div class="card-body">
              @if(submitted && loginErrorMessage != undefined){
                <div>
                  <span class="login-validation">{{loginErrorMessage}}</span>
                </div>
              }
              <div class="form-row">
                <div class="form-group col">
                  <!--<label>{{ "login.username" | translate }}</label>-->
                  <label style="float: left;">Username</label>
                  <kendo-textbox class="form-textbox" formControlName="username"></kendo-textbox>
                  @if(submitted && f['username'].errors){
                  <div class="k-tooltip-validation">
                    @if(f['username'].errors['required']){
                    <div class="validationMsg">Username is required</div>
                    }
                  </div>
                  }
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col">
                  <!--<label>{{ "login.password" | translate }}</label>-->
                  <label style="float: left;">Password</label>
                  <input class="form-textbox" kendoTextBox type="password" formControlName="password" />
                  @if(submitted && f['password'].errors){
                  <div class="k-tooltip-validation">
                    @if(f['password'].errors['required']){
                    <div class="validationMsg">Password is required</div>
                    }
                  </div>
                  }
                </div>
              </div>
              <div class="form-row">
                <!--<a class="forgotPassword">{{ "login.forgotPassword" | translate }}</a>-->
                <a class="forgotPassword" (click)="redirectToForgotPasswordPage()">Forgot Password</a>
              </div>
            </div>
            <div class="card-footer">
              <button kendoButton type="submit" class="primary btnLogin">
                <span id="iconContainer" style="display:block;float:left"><fa-icon [icon]="icon"></fa-icon></span>
                &nbsp;&nbsp;
                <!--{{ "login.login" | translate }}-->
                Login
              </button>
            </div>
          </form>
        </kendo-card>
      </div>
    </div>
  }
</kendo-stacklayout>
